import { get, includes } from 'lodash';

import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/styles';
import createLinkPlugin from '@draft-js-plugins/anchor';
import { royalblue } from '../../../../constants/Colors';
import PositionContext from '../../../../contexts/PositionContext';
import EmployerContext from '../../../../contexts/EmployerContext';
import {
    TextTemplateValues,
} from '../../../../modules/email/email-editor/template-text-plugin/TemplateTextConsts';

export const useStyles = makeStyles(() => ({
    disabledLink: {
        color: royalblue,
        textDecoration: 'underline',
        cursor: 'pointer',
    },
}));

const positionDescriptionPageHrefValues = [
    TextTemplateValues.positionDescriptionLink,
    TextTemplateValues.positionDescriptionThisPageLink,
    TextTemplateValues.positionDescriptionHereLink,
    TextTemplateValues.positionDescriptionPageLink,
];
const unsubscribeHrefValues = [
    TextTemplateValues.unsubscribeLink,
];

const CustomLink = (props) => {
    const {
        className,
        children,
        contentState,
        entityKey,
        disabled,
        linkContext = {},
    } = props;

    const classes = useStyles();
    const entity = contentState.getEntity(entityKey);
    const entityData = entity ? entity.get('data') : undefined;
    const url = entityData && entityData.url;
    const href = linkContext[url] || url;

    const { positionId } = useContext(PositionContext);
    const { employer } = useContext(EmployerContext);

    const isNewLandingPageEnabled = get(employer, 'settings.isNewLandingPageEnabled');
    const positionDescriptionRouteVersion = isNewLandingPageEnabled ? 'position-description-v2' : 'position-description';
    const companyVideoUrl = get(employer, 'settings.videoUrl');

    if (disabled) {
        return (
            <a className={classes.disabledLink}>{children}</a>
        );
    }
    const handleLinkClick = () => {
        switch (true) {
            case includes(positionDescriptionPageHrefValues, href):
                window.open(`/public/${positionDescriptionRouteVersion}/${positionId}?showDisabledForm=true`, '_blank');
                break;
            case href === TextTemplateValues.companyVideoLink && companyVideoUrl:
                window.open(companyVideoUrl, '_blank');
                break;
            case includes(unsubscribeHrefValues, href):
                break;
            case !positionId || !companyVideoUrl:
                break;
            case href === TextTemplateValues.employerCompanyLink:
                break;
            default:
                window.open(href, '_blank');
        }
    };
    return (
        <a href={href}
            onClick={handleLinkClick}
            className={className}
            style={{ cursor: 'pointer' }}
            target={'_blank'}
            rel="noreferrer"
        >
            {children}
        </a>
    );
};

export default (config) => createLinkPlugin({
    ...config,
    Link: (linkProps) => <CustomLink {...linkProps} disabled={config.disableLink} linkContext={config.context}/>,
});
